export default __webpack_public_path__ + "static/media/portfolio.a1c2e006.svg";